// extracted by mini-css-extract-plugin
module.exports = {"OverWindow":"OverWindow_OverWindow__D2fQi","Video":"OverWindow_Video__28Krk","Back":"OverWindow_Back__1XGK4","Top":"OverWindow_Top__2N4nc"};